import cloneDeep from 'lodash.clonedeep';
import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { Xtp, XtpOptions, XtpFormData } from 'data/xtp/xtp.types';

export function getXtpDataToSubmit(
  xtpData: XtpFormData,
  originalXtpFormData?: Xtp | null,
): XtpFormData {

  const clonedData = cloneDeep(xtpData)

  return {
    main: clonedData.main,
    xtpOptions: clonedData.xtpOptions
  };
}

export function getXtpAuditDetailsToSubmit(
  xtpData: Xtp,
  originalXtpFormData: Xtp | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.XTP_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.XTP_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(xtpData, null, isEdit, originalXtpFormData),
    xtpData.lbId,
    AuditService.XTP,
    actionType,
  );
  return auditDetails as AuditDetails;
}

export function getXtpOptionsAuditDetailsToSubmit(
  xtpOptionData: XtpOptions,
  originalXtpFormData: XtpOptions | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.XTP_OPTIONS_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.XTP_OPTIONS_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(xtpOptionData, null, isEdit, originalXtpFormData),
    xtpOptionData.id,
    AuditService.XTP_OPTIONS,
    actionType,
  );
  return auditDetails as AuditDetails;
}
